import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "upload-business" }
const _hoisted_2 = { class: "upload-business__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "upload-business__sub-title sub-title" }
const _hoisted_5 = { class: "sub-title__text" }
const _hoisted_6 = { class: "sub-title__text--note" }
const _hoisted_7 = { class: "sub-title__header-input header-input" }
const _hoisted_8 = { class: "header-input__label" }
const _hoisted_9 = { class: "header-input__input-text" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "header-input__input-text--unit" }
const _hoisted_12 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_13 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_14 = {
  key: 2,
  class: "header-input__input-text--error"
}
const _hoisted_15 = { class: "upload-business__upload-container" }
const _hoisted_16 = {
  key: 0,
  "data-testid": `input_file_content`,
  class: "dz-file-preview dz-preview"
}
const _hoisted_17 = { class: "dz-details" }
const _hoisted_18 = { class: "file-name-and-size" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "dz-default" }
const _hoisted_21 = { class: "upload-business__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import HelpIconWithModal from '@/corePagesModule/components/HelpIconWithModal.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import { ReadFileService } from '@/registerInputModule/service/ReadFileService';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadBusiness',
  props: {
    store: {}
  },
  emits: ["on-click-next", "on-click-back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);

const emits = __emit;

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-1.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-1.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-1__en.png') : imagesRequire('./register-input-step-flow-1.png');
  },
  {
    immediate: true,
  }
);

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

/**
 * 次へボタン
 */
const onClickNextButton = () => {
  emits('on-click-next');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引アップロード：タイトル')), 1),
    _createElementVNode("img", {
      src: localedRegisterInputStepFlowImage.value,
      class: "upload-business__progress"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('取引アップロード：本文')), 1),
        _createVNode(HelpIconWithModal, {
          "use-transform": true,
          class: "sub-title__text--help-icon"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('')), 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('行番号')), 1),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).uploadBusiness.businessInputHeaderNumber.value) = $event)),
            class: "header-input__input-text--form",
            type: "number",
            placeholder: _unref(t)('半角数字')
          }, null, 8, _hoisted_10), [
            [_vModelText, _unref(state).uploadBusiness.businessInputHeaderNumber.value]
          ]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('行')), 1)
        ]),
        (_unref(state).uploadBusiness.businessInputHeaderNumber.validateError == 'AtLeastOne')
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)('取引設定：数値バリデーション：1以上エラー')), 1))
          : (_unref(state).uploadBusiness.businessInputHeaderNumber.validateError == 'Empty')
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(t)('取引設定：数値バリデーション：空文字エラー')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString('　')))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _mergeProps(_ctx.store.getRootProps(), { class: "mb-20px dropzone" }), [
        _createElementVNode("input", _mergeProps(_ctx.store.getInputProps(), { "data-testid": `dropzone_input_area` }), null, 16),
        (_unref(state).uploadBusiness.inputFile != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(state).uploadBusiness.inputFile], (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "dz-file-content"
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_unref(ReadFileService).fetchNameForEvent(file)), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(ReadFileService).getFileSizeStr(file)), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "dz-remove",
                      onClick: _withModifiers(($event: any) => (_ctx.store.handleClickDeleteFile(index)), ["stop"])
                    }, " Delete ", 8, _hoisted_19)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: _normalizeClass(["dz-message", _ctx.store.isDragActive])
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("i", null, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('ここにファイルをドロップ')), 1)
          ], 2)
        ])
      ], 16)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(TextButton, {
        "button-style": 'btn-primary',
        size: 'btn-md',
        "on-click": onClickNextButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：次へボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})